const Cliente = {
	exec(cmd, data) {
		return new Promise((resolve, reject) => {
			$.ajax({
				url: `minha-conta/${cmd}`,
				type: "post",
				dataType: "json",
				data: data
			})
			.then(resp => {
				if (resp.success) {
					resolve(resp);
				} else {
					reject(new Error(resp.msg));
				}
				if (typeof resp.redirect_url != "undefined") {
					location.href = resp.redirect_url;
				}
			})
			.catch(err => {
				reject(
					new Error("Não foi possível completar a solicitação.")
				);
			});
		});
	},
	login(email, senha, lembrar = 0, referer) {
		return this.exec("do-login", { email, senha, lembrar, referer });
	},
	preCadastro(email, senha) {
		return this.exec("pre-cadastro", { email, senha });
	},
	save(data) {
		return this.exec("save", data);
	},
	salvarEndereco(data) {
		return this.exec("salvar-endereco", data);
	},
	removerEndereco(id) {
		return this.exec("remover-endereco", { id });
	},
	esqueceuSenha(email) {
		return this.exec('esqueceu-senha', { email });
	}
};

$("body").on("submit", "[name=formLogin]", function () {
	const $self = $(this);
	if ($self.data("enviando")) {
		return false;
	}
	if (!$self.find(".required").validate()) {
		return false;
	}
	
	$self.data("enviando", true);
	$.fancybox.showLoading();
	
	const email = $self.find("[name=email]").val();
	const senha = $self.find("[name=senha]").val();
	const lembrar = $self.find("[name=lembrar]:checked").val() | 0;
	const referer = $self.find("[name=referer]").val();
	
	Cliente.login(email, senha, lembrar, referer)
	.then(resp => {
		if (typeof fbq !== 'undefined') {
			fbq('track', 'Login', {
				em: email,  // O Facebook irá fazer o hash do email automaticamente
			});
		}
		if ("undefined" != typeof resp.redirect_url) {
			location.href = resp.redirect_url;
		} else {
			location.reload(true);
		}
	})
	.catch(err => {
		alert(err.message);
		$.fancybox.hideLoading();
		$self.data("enviando", false);
	});
	
	return false;
});

$("body").on("submit", "[name=formPreCadastro]", function () {
	const $self = $(this);
	if ($self.data("enviando")) {
		return false;
	}
	if (!$self.find(".required").validate()) {
		return false;
	}
	
	$self.data("enviando", true);
	$.fancybox.showLoading();
	
	const email = $self.find("[name=email]").val();
	const senha = $self.find("[name=senha]").val();
	
	Cliente.preCadastro(email, senha)
	.then(resp => {
		if ("undefined" != typeof resp.redirect_url) {
			location.href = resp.redirect_url;
		} else {
			location.reload(true);
		}
	})
	.catch(err => {
		alert(err.message);
		$.fancybox.hideLoading();
		$self.data("enviando", false);
	});
	
	return false;
});

$("body").on("submit", "[name=formCadastro]", function () {
	const $self = $(this);
	
	if ($self.data("enviando")) {
		return false;
	}
	
	if (!$self.find(".required").validate()) {
		return false;
	}
	
	$self.data("enviando", true);
	$.fancybox.showLoading();
	
	const nome = $self.find("[name=nome]").val();
	const email = $self.find("[name=email]").val();
	const cpf = $self.find("[name=cpf]").val();
	const telefone = $self.find("[name=telefone]").val();
	const senha = $self.find("[name=senha]").val();
	const senha2 = $self.find("[name=senha2]").val();
	const pc = $self.find("[name=pc]").val() | 0;
	
	if (!/^[^\s]+(\s+[^\s]+)+\s*$/.test(nome)) {
		alert("Informe o nome completo.");
		$self.find("[name=nome]").focus();
		return false;
	}
	
	Cliente.save({
		nome,
		email,
		cpf,
		telefone,
		senha,
		senha2,
		pc
	})
	.then(resp => {
		alert(resp.msg);
		location.reload(true);
	})
	.catch(err => {
		alert(err.message);
		$.fancybox.hideLoading();
		$self.data("enviando", false);
	});
	
	return false;
});

$("body").on("submit", "[name=formEndereco]", function () {
	const $self = $(this);
	if ($self.data("enviando")) {
		return false;
	}
	if (!$self.find(".required").validate()) {
		return false;
	}
	$self.data("enviando", true);
	$.fancybox.showLoading();
	Cliente.salvarEndereco($self.serializeArray())
	.then(resp => {
		alert(resp.msg);
		if (typeof resp.redirect_url == "undefined") {
			location.reload(true);
		}
	})
	.catch(err => {
		alert(err.message);
	})
	.then(() => { });
	
	return false;
});

$("body").on("keyup", "[name=cep]", function () {
	const $cep = $(this);
	const $form = $cep.closest("form");
	
	const cep = $cep.val().replace(/\D/gim, "");
	if (8 != cep.length) {
		return;
	}
	
	$.fancybox.showLoading();
	
	$.ajax({
		url: `https://cep.studiogt.com.br/ws/${cep}/json/`,
		type: "get",
		dataType: "json"
	})
	.then(resp => {
		resp.cidade = resp.localidade;
		delete resp.localidade;
		delete resp.unidade;
		delete resp.ibge;
		delete resp.gia;
		delete resp.complemento;
		$.each(resp, (name, val) => {
			$form.find(`[name=${name}]`).val(val);
		});
	})
	.catch(err => {
		console.log(err);
	})
	.then(() => {
		$.fancybox.hideLoading();
	});
});

$("body").on("click", ".btn-remover-endereco", function () {
	var $self = $(this);
	var id = $self.data("id") | 0;
	
	$.fancybox.showLoading();
	Cliente.removerEndereco(id)
	.then(resp => { })
	.catch(err => {
		alert(err.message);
	})
	.then(() => {
		location.reload(true);
	});
});


$("body").on("submit", "[name=formEsqueceuSenha]", function () {
	const $self = $(this);
	const $email = $self.find('[name=email]');
	const email = $email.val();
	
	if (!$email.validate()) {
		return false;
	}
	
	$.fancybox.showLoading();
	Cliente.esqueceuSenha(email)
	.then(resp => {
		alert(resp.msg);
		$.fancybox.close();
	})
	.catch(err => {
		alert(err.message);
	})
	.then(() => {
		$.fancybox.hideLoading();
	});
	
	
	return false;
});